<div class="wrapper">
  <div class="heading text-type-2 mb-[20px] flex flex-row justify-between items-center">
    <div class="title text-type-2">Add location or station</div>
    <mat-icon class="cursor-pointer" (click)="cancel()">close</mat-icon>
  </div>

  @if (hasField('station')) {
    <div class="row flex flex-row gap-[20px] mb-[20px]">
      <app-text-input
        [parentFormGroup]="form"
        controlName="station"
        [label]="labelFor('station')"
        class="flex-1 min-w-0"
      />
      @if (hasField('station_plus')) {
        <app-text-input
          [parentFormGroup]="form"
          controlName="station_plus"
          [label]="labelFor('station_plus')"
          class="flex-1 min-w-0"
        />
      }
    </div>
  }

  @if (hasField('offset_distance') || hasField('offset_direction')) {
    <div class="row flex flex-row gap-[20px] mb-[20px]">
      @if (hasField('offset_distance')) {
        <app-number-input
          [parentFormGroup]="form"
          controlName="offset_distance"
          [isDecimalAllowed]="true"
          [label]="labelFor('offset_distance')"
          class="flex-1 min-w-0"
        />
      }
      @if (hasField('offset_direction')) {
        <app-dropdown
          [parentFormGroup]="form"
          controlName="offset_direction"
          [options]="offsetDirectionOptions"
          [enableSearch]="true"
          [label]="labelFor('offset_direction')"
          class="flex-1 min-w-0"
        />
      }
    </div>
  }

  @if (hasField('grade_reference')) {
    <app-text-input
      [parentFormGroup]="form"
      controlName="grade_reference"
      [label]="labelFor('grade_reference')"
      [maxLength]="500"
      class="w-full mb-[20px]"
    />
  }

  @if (hasField('latitude') || hasField('longitude')) {
    <div class="row flex flex-row gap-[20px] mb-[20px]">
      @if (hasField('latitude')) {
        <app-text-input
          [parentFormGroup]="form"
          controlName="latitude"
          [label]="labelFor('latitude')"
          [maxLength]="32"
          class="flex-1 min-w-0"
        />
      }
      @if (hasField('longitude')) {
        <app-text-input
          [parentFormGroup]="form"
          controlName="longitude"
          [label]="labelFor('longitude')"
          [maxLength]="32"
          class="flex-1 min-w-0"
        />
      }
    </div>
  }

  @if (form?.get('latitude')?.value && form?.get('longitude')?.value) {
    <div class="location-preview mb-[20px]">
      <app-location-picker
        [latitude]="form.get('latitude')?.value"
        [longitude]="form.get('longitude')?.value"
        [readOnly]="true"
        [isDialog]="false"
        height="160px"
      />
    </div>
  }

  <div class="action-section w-full flex flex-row justify-end items-center mt-[20px]">
    <app-primary-button (handleClick)="done()" class="w-[160px]">
      Done
    </app-primary-button>
  </div>
</div>
